/**
 * Кнопка для открытия AI ассистента
 */

import { Bot, Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

interface AiAssistantTriggerProps {
  onClick: () => void;
  variant?: 'default' | 'header' | 'fab';
  className?: string;
}

/**
 * Кнопка для header
 */
function HeaderTrigger({ onClick, className }: { onClick: () => void; className?: string }) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            onClick={onClick}
            className={cn('relative', className)}
          >
            <Bot className="h-5 w-5" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>AI Ассистент</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

/**
 * Плавающая кнопка (FAB)
 */
function FabTrigger({ onClick, className }: { onClick: () => void; className?: string }) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            size="icon"
            onClick={onClick}
            className={cn(
              'fixed bottom-6 right-6 z-50',
              'h-14 w-14 rounded-full shadow-lg',
              'bg-primary hover:bg-primary/90',
              'transition-transform hover:scale-105',
              className
            )}
          >
            <Sparkles className="h-6 w-6" />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="left">
          <p>AI Ассистент</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

/**
 * Обычная кнопка
 */
function DefaultTrigger({ onClick, className }: { onClick: () => void; className?: string }) {
  return (
    <Button
      variant="outline"
      onClick={onClick}
      className={cn('gap-2', className)}
    >
      <Bot className="h-4 w-4" />
      <span>AI Ассистент</span>
    </Button>
  );
}

export function AiAssistantTrigger({
  onClick,
  variant = 'default',
  className,
}: AiAssistantTriggerProps) {
  switch (variant) {
    case 'header':
      return <HeaderTrigger onClick={onClick} className={className} />;
    case 'fab':
      return <FabTrigger onClick={onClick} className={className} />;
    default:
      return <DefaultTrigger onClick={onClick} className={className} />;
  }
}
